import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import { addAgent, getAllCellules, getAllBureaux, getAllGrades, getAllFonctions, getAllCategoriesProfessionnelles } from '../services/api';

const Enrolement = () => {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    post_nom: '',
    sexe: '',
    etat_civil: '',
    titre_academique: '',
    filiere: '',
    date_naissance: '',
    lieu_naissance: '',
    nationalite: 'Congolaise',
    telephone: '',
    email: '',
    adresse: '',
    id_agent: '',
    matricule: '',
    categorie: '',
    bureau: '',
    cellule: '',
    grade: '',
    fonction: '',
    date_affectation: '',
    ref_affectation: '',
    zone_affectation: '',
    lieu_affectation: '',
    situation_prime: '',
    arrete: false,
    commission_affectation_sg: false,
    commission_affectation_locale: false,
    notification_fonc_publique_ville: false,
    commission_local_fonc_publique_ville: false,
    notification_nu: false,
  });

  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploading, setUploading] = useState(false);
  const [empreinteDigitale, setEmpreinteDigitale] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);
  const [cellules, setCellules] = useState([]);
  const [bureaux, setBureaux] = useState([]);
  const [grades, setGrades] = useState([]);
  const [fonctions, setFonctions] = useState([]);
  const [categoriesProfessionnelles, setCategoriesProfessionnelles] = useState([]);
  const situationPrimeOptions = [
    { value: 'P', label: 'Primé (P)' },
    { value: 'NP', label: 'Non Primé (N.P)' },
  ];

  const etatCivilOptions = [
    { value: 'celibataire', label: 'Célibataire' },
    { value: 'marie', label: 'Marié(e)' },
    { value: 'divorce', label: 'Divorcé(e)' },
    { value: 'veuf', label: 'Veuf(ve)' },
    { value: 'separe', label: 'Séparé(e)' },
  ];

  const titreAcademiqueOptions = [
    { value: 'aucun', label: 'Aucun' },
    { value: 'cepe', label: 'CEPE (Certificat d\'Études Primaires Élémentaires)' },
    { value: 'brevet', label: 'Brevet d\'Études du Premier Cycle (BEPC)' },
    { value: 'baccalaureat', label: 'Diplôme d\'état' },
    { value: 'diplome_technique', label: 'Diplôme Technique' },
    { value: 'licence', label: 'Licence' },
    { value: 'graduat', label: 'Graduat' },
    { value: 'master', label: 'Master' },
    { value: 'doctorat', label: 'Doctorat' },
    { value: 'autre', label: 'Autre' },
  ];
  const fileInputRef = useRef(null);
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  useEffect(() => {
    loadCellules();
    loadBureaux();
    loadGrades();
    loadFonctions();
    loadCategoriesProfessionnelles();
    generateIdAgent();
  }, []);

  const generateIdAgent = async () => {
    try {
      // Générer un id_agent temporaire côté client (sera validé/généré côté serveur)
      // Format: MAT-AG-MT-00001
      const timestamp = Date.now();
      const randomNum = Math.floor(Math.random() * 1000);
      const tempNum = String((timestamp % 100000) + randomNum).padStart(5, '0').slice(0, 5);
      const tempIdAgent = `MAT-AG-MT-${tempNum}`;
      setFormData(prev => ({ ...prev, id_agent: tempIdAgent }));
    } catch (error) {
      console.error('Erreur lors de la génération de l\'ID agent:', error);
    }
  };

  const loadGrades = async () => {
    try {
      const data = await getAllGrades();
      setGrades(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erreur lors du chargement des grades:', error);
      setGrades([]);
    }
  };

  const loadFonctions = async () => {
    try {
      const data = await getAllFonctions();
      setFonctions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erreur lors du chargement des fonctions:', error);
      setFonctions([]);
    }
  };

  const loadCategoriesProfessionnelles = async () => {
    try {
      const data = await getAllCategoriesProfessionnelles();
      setCategoriesProfessionnelles(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erreur lors du chargement des catégories professionnelles:', error);
      setCategoriesProfessionnelles([]);
    }
  };

  const loadCellules = async () => {
    try {
      const data = await getAllCellules();
      console.log('Cellules chargées:', data);
      setCellules(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erreur lors du chargement des cellules:', error);
      setCellules([]);
    }
  };

  const loadBureaux = async () => {
    try {
      const data = await getAllBureaux();
      console.log('Bureaux chargés:', data);
      setBureaux(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erreur lors du chargement des bureaux:', error);
      setBureaux([]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCelluleChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, cellule: selectedOption ? selectedOption.value : '' }));
  };

  const handleBureauChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, bureau: selectedOption ? selectedOption.value : '' }));
  };

  const handleCategorieChange = (selectedOption) => {
    const categorieValue = selectedOption ? selectedOption.value : '';
    const categorieLabel = selectedOption ? selectedOption.label : '';
    setFormData((prev) => ({ 
      ...prev, 
      categorie: categorieValue,
      // Réinitialiser les checkboxes quand on change de catégorie
      arrete: false,
      commission_affectation_sg: false,
      commission_affectation_locale: false,
      notification_fonc_publique_ville: false,
      commission_local_fonc_publique_ville: false,
      notification_nu: false,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  // Vérifier si la catégorie sélectionnée est "sous statut" ou "nouvelle unité"
  const getSelectedCategorieLabel = () => {
    if (!formData.categorie) return '';
    const selected = categoriesProfessionnelles.find(
      (c) => (c.id || c.nom) == formData.categorie || c.nom === formData.categorie
    );
    return selected ? selected.nom.toLowerCase() : '';
  };

  const isSousStatut = () => {
    const label = getSelectedCategorieLabel();
    return label.includes('sous statut') || label === 'sous statut';
  };

  const isNouvelleUnite = () => {
    const label = getSelectedCategorieLabel();
    return label.includes('nouvelle unité') || label.includes('nouvelle unite') || label === 'nouvelle unité' || label === 'nouvelle unite';
  };

  const handleGradeChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, grade: selectedOption ? selectedOption.value : '' }));
  };

  const handleFonctionChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, fonction: selectedOption ? selectedOption.value : '' }));
  };

  const handleSituationPrimeChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, situation_prime: selectedOption ? selectedOption.value : '' }));
  };

  const handleEtatCivilChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, etat_civil: selectedOption ? selectedOption.value : '' }));
  };

  const handleTitreAcademiqueChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, titre_academique: selectedOption ? selectedOption.value : '' }));
  };

  const handlePhotoCapture = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          streamRef.current = stream;
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
          }
        })
        .catch((err) => {
          setMessage({ type: 'error', text: 'Erreur d\'accès à la caméra: ' + err.message });
        });
    } else {
      setMessage({ type: 'error', text: 'La caméra n\'est pas disponible' });
    }
  };

  const capturePhoto = () => {
    if (videoRef.current) {
      const canvas = document.createElement('canvas');
      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(videoRef.current, 0, 0);
      canvas.toBlob((blob) => {
        setPhoto(blob);
        setPhotoPreview(URL.createObjectURL(blob));
        stopCamera();
      }, 'image/jpeg', 0.9);
    }
  };

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      if (type === 'photo') {
        setPhoto(file);
        setPhotoPreview(URL.createObjectURL(file));
      }
    }
  };

  const handleDocumentsChange = (e) => {
    const files = Array.from(e.target.files);
    const imageFiles = files.filter(file => file.type.startsWith('image/'));
    
    if (imageFiles.length > 0) {
      const newDocuments = imageFiles.map(file => ({
        id: Date.now() + Math.random(),
        file: file,
        preview: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
        progress: 0,
        status: 'pending' // pending, uploading, success, error
      }));
      setDocuments(prev => [...prev, ...newDocuments]);
    }
  };

  const removeDocument = (id) => {
    setDocuments(prev => {
      const doc = prev.find(d => d.id === id);
      if (doc && doc.preview) {
        URL.revokeObjectURL(doc.preview);
      }
      return prev.filter(d => d.id !== id);
    });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const files = Array.from(e.dataTransfer.files);
    const imageFiles = files.filter(file => file.type.startsWith('image/'));
    
    if (imageFiles.length > 0) {
      const newDocuments = imageFiles.map(file => ({
        id: Date.now() + Math.random(),
        file: file,
        preview: URL.createObjectURL(file),
        name: file.name,
        size: file.size,
        progress: 0,
        status: 'pending'
      }));
      setDocuments(prev => [...prev, ...newDocuments]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const data = new FormData();
      
      // Ajouter les champs du formulaire en convertissant toutes les valeurs en chaînes
      Object.keys(formData).forEach((key) => {
        const value = formData[key];
        // Inclure les valeurs booléennes (même false) et les valeurs non vides
        if (value !== null && value !== undefined && (value !== '' || typeof value === 'boolean')) {
          // Convertir en chaîne si ce n'est pas déjà une chaîne ou un fichier
          if (typeof value === 'boolean') {
            data.append(key, value ? 'true' : 'false');
          } else if (typeof value === 'string' || typeof value === 'number') {
            data.append(key, String(value));
          } else if (value instanceof File || value instanceof Blob) {
            data.append(key, value);
          } else {
            // Pour les autres types (objets, etc.), convertir en chaîne JSON ou ignorer
            console.warn(`Valeur non supportée pour ${key}:`, value);
            data.append(key, String(value));
          }
        }
      });

      if (photo) {
        data.append('photo', photo);
      }
      
      // Ajouter tous les documents
      documents.forEach((doc) => {
        if (doc.file) {
          data.append('documents', doc.file);
        }
      });
      
      if (empreinteDigitale) {
        data.append('empreinte_digitale', empreinteDigitale);
      }

      // Log pour débogage
      console.log('📤 Envoi des données:');
      console.log('  - Photo:', photo ? (photo.name || 'Blob') : 'Aucune');
      console.log('  - Documents:', documents.length);
      console.log('  - FormData keys:', Array.from(data.keys()));

      const result = await addAgent(data);
      
      // Gérer la structure de réponse
      const agentData = result.data || result;
      const matricule = agentData.matricule || result.matricule;
      
      setMessage({ type: 'success', text: 'Agent enregistré avec succès! Matricule: ' + matricule });
      
      // Reset form
      setFormData({
        nom: '',
        prenom: '',
        post_nom: '',
        sexe: '',
        etat_civil: '',
        titre_academique: '',
        filiere: '',
        date_naissance: '',
        lieu_naissance: '',
        nationalite: 'Congolaise',
        telephone: '',
        email: '',
        adresse: '',
        id_agent: '',
        matricule: '',
        categorie: '',
        bureau: '',
        cellule: '',
        grade: '',
        fonction: '',
        date_affectation: '',
        ref_affectation: '',
        zone_affectation: '',
        lieu_affectation: '',
        situation_prime: '',
        arrete: false,
        commission_affectation_sg: false,
        commission_affectation_locale: false,
        notification_fonc_publique_ville: false,
        commission_local_fonc_publique_ville: false,
        notification_nu: false,
      });
      generateIdAgent();
      setPhoto(null);
      setPhotoPreview(null);
      setDocuments([]);
      setUploadProgress({});
      setEmpreinteDigitale('');
    } catch (error) {
      console.error('Erreur lors de l\'enregistrement:', error);
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Erreur lors de l\'enregistrement',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 bg-background min-h-screen">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-text mb-8 flex items-center">
          <i className="fas fa-user-plus mr-3 text-primary"></i>
          Enrôlement d'un Nouvel Agent
        </h1>

        <form onSubmit={handleSubmit} className="bg-cardBg rounded-lg shadow-lg p-8">
          {/* Photo Section */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-text mb-4">
              <i className="fas fa-camera mr-2 text-primary"></i>Photo
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                {photoPreview ? (
                  <div className="relative">
                    <img
                      src={photoPreview}
                      alt="Preview"
                      className="w-full h-64 object-cover rounded-lg border-2 border-primary"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setPhoto(null);
                        setPhotoPreview(null);
                      }}
                      className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                ) : (
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                    <i className="fas fa-image text-4xl text-gray-400 mb-4"></i>
                    <p className="text-text-light mb-4">Aucune photo</p>
                    <div className="space-x-2">
                      <button
                        type="button"
                        onClick={handlePhotoCapture}
                        className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark"
                      >
                        <i className="fas fa-camera mr-2"></i>Prendre une photo
                      </button>
                      <button
                        type="button"
                        onClick={() => fileInputRef.current?.click()}
                        className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
                      >
                        <i className="fas fa-upload mr-2"></i>Importer
                      </button>
                    </div>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, 'photo')}
                      className="hidden"
                    />
                  </div>
                )}
                {streamRef.current && (
                  <div className="mt-4">
                    <video ref={videoRef} autoPlay className="w-full rounded-lg"></video>
                    <button
                      type="button"
                      onClick={capturePhoto}
                      className="mt-2 w-full px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark"
                    >
                      <i className="fas fa-camera mr-2"></i>Capturer
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Informations Personnelles */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-text mb-4">
              <i className="fas fa-user mr-2 text-primary"></i>Informations Personnelles
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-text mb-2">Nom *</label>
                <input
                  type="text"
                  name="nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Prénom *</label>
                <input
                  type="text"
                  name="prenom"
                  value={formData.prenom}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Post-nom</label>
                <input
                  type="text"
                  name="post_nom"
                  value={formData.post_nom}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Sexe *</label>
                <select
                  name="sexe"
                  value={formData.sexe}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                >
                  <option value="">Sélectionner</option>
                  <option value="M">Masculin</option>
                  <option value="F">Féminin</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">État Civil</label>
                <Select
                  value={
                    etatCivilOptions.find(
                      (option) => option.value === formData.etat_civil
                    ) || null
                  }
                  onChange={handleEtatCivilChange}
                  options={etatCivilOptions}
                  isClearable
                  placeholder="Sélectionner l'état civil"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#d1d5db',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#00A896',
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#00A896'
                        : state.isFocused
                        ? '#E0F7F5'
                        : 'white',
                      color: state.isSelected ? 'white' : '#333',
                      '&:hover': {
                        backgroundColor: state.isSelected ? '#00A896' : '#E0F7F5',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Titre Académique</label>
                <Select
                  value={
                    titreAcademiqueOptions.find(
                      (option) => option.value === formData.titre_academique
                    ) || null
                  }
                  onChange={handleTitreAcademiqueChange}
                  options={titreAcademiqueOptions}
                  isClearable
                  isSearchable
                  placeholder="Sélectionner le titre académique"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#d1d5db',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#00A896',
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#00A896'
                        : state.isFocused
                        ? '#E0F7F5'
                        : 'white',
                      color: state.isSelected ? 'white' : '#333',
                      '&:hover': {
                        backgroundColor: state.isSelected ? '#00A896' : '#E0F7F5',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Filière</label>
                <input
                  type="text"
                  name="filiere"
                  value={formData.filiere}
                  onChange={handleInputChange}
                  placeholder="Entrer la filière"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Date de naissance</label>
                <input
                  type="date"
                  name="date_naissance"
                  value={formData.date_naissance}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Lieu de naissance</label>
                <input
                  type="text"
                  name="lieu_naissance"
                  value={formData.lieu_naissance}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Nationalité</label>
                <input
                  type="text"
                  name="nationalite"
                  value={formData.nationalite}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Téléphone</label>
                <input
                  type="tel"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-text mb-2">Adresse</label>
                <textarea
                  name="adresse"
                  value={formData.adresse}
                  onChange={handleInputChange}
                  rows="3"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
            </div>
          </div>

          {/* Informations Professionnelles */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-text mb-4">
              <i className="fas fa-briefcase mr-2 text-primary"></i>Informations Professionnelles
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-text mb-2">ID Agent</label>
                <input
                  type="text"
                  name="id_agent"
                  value={formData.id_agent}
                  onChange={handleInputChange}
                  placeholder="MAT-AG-MT-00001"
                  readOnly
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none bg-gray-100 cursor-not-allowed"
                />
                <p className="text-xs text-text-light mt-1">Format: MAT-AG-MT-XXXXX (5 chiffres) - Généré automatiquement</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Matricule</label>
                <input
                  type="text"
                  name="matricule"
                  value={formData.matricule}
                  onChange={handleInputChange}
                  placeholder="Entrer le matricule manuellement"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
                <p className="text-xs text-text-light mt-1">Saisir le matricule manuellement</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Catégorie *</label>
                <Select
                  value={
                    formData.categorie && categoriesProfessionnelles.length > 0
                      ? categoriesProfessionnelles
                          .filter((c) => {
                            const catValue = c.id || c.nom;
                            return catValue == formData.categorie || c.nom === formData.categorie;
                          })
                          .map((c) => ({
                            value: c.id || c.nom,
                            label: c.nom || String(c.id || c.nom),
                          }))[0] || null
                      : null
                  }
                  onChange={handleCategorieChange}
                  options={categoriesProfessionnelles.map((c) => ({
                    value: c.id || c.nom,
                    label: c.nom || String(c.id || c.nom),
                  }))}
                  isClearable
                  isSearchable
                  placeholder={categoriesProfessionnelles.length === 0 ? "Chargement des catégories..." : "Sélectionner une catégorie"}
                  isLoading={categoriesProfessionnelles.length === 0}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#d1d5db',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#00A896',
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#00A896'
                        : state.isFocused
                        ? '#E0F7F5'
                        : 'white',
                      color: state.isSelected ? 'white' : '#333',
                      '&:hover': {
                        backgroundColor: state.isSelected ? '#00A896' : '#E0F7F5',
                      },
                    }),
                  }}
                />
              </div>
              
              {/* Checkboxes pour "Sous statut" */}
              {isSousStatut() && (
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-text mb-3">Options Sous Statut</label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        name="arrete"
                        checked={formData.arrete}
                        onChange={handleCheckboxChange}
                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                      />
                      <span className="ml-2 text-sm text-text">Arrêté</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        name="commission_affectation_sg"
                        checked={formData.commission_affectation_sg}
                        onChange={handleCheckboxChange}
                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                      />
                      <span className="ml-2 text-sm text-text">Commission d'affectation SG</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        name="commission_affectation_locale"
                        checked={formData.commission_affectation_locale}
                        onChange={handleCheckboxChange}
                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                      />
                      <span className="ml-2 text-sm text-text">Commission d'affectation Locale</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        name="notification_fonc_publique_ville"
                        checked={formData.notification_fonc_publique_ville}
                        onChange={handleCheckboxChange}
                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                      />
                      <span className="ml-2 text-sm text-text">Notification Fonc Publique/Ville</span>
                    </label>
                  </div>
                </div>
              )}

              {/* Checkboxes pour "Nouvelle unité" */}
              {isNouvelleUnite() && (
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-text mb-3">Options Nouvelle Unité</label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        name="commission_local_fonc_publique_ville"
                        checked={formData.commission_local_fonc_publique_ville}
                        onChange={handleCheckboxChange}
                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                      />
                      <span className="ml-2 text-sm text-text">Commission local fonction Publique/ville</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        name="notification_nu"
                        checked={formData.notification_nu}
                        onChange={handleCheckboxChange}
                        className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                      />
                      <span className="ml-2 text-sm text-text">Notification N.U</span>
                    </label>
                  </div>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-text mb-2">Bureau</label>
                <Select
                  value={
                    formData.bureau && bureaux.length > 0
                      ? bureaux
                          .filter((b) => {
                            const bureauValue = b.id || b.nom;
                            return bureauValue == formData.bureau || b.nom === formData.bureau;
                          })
                          .map((b) => ({
                            value: b.id || b.nom,
                            label: b.nom || String(b.id || b.nom),
                          }))[0] || null
                      : null
                  }
                  onChange={handleBureauChange}
                  options={bureaux.map((b) => ({
                    value: b.id || b.nom,
                    label: b.nom || String(b.id || b.nom),
                  }))}
                  isClearable
                  isSearchable
                  placeholder={bureaux.length === 0 ? "Chargement des bureaux..." : "Sélectionner un bureau"}
                  isLoading={bureaux.length === 0}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#d1d5db',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#00A896',
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#00A896'
                        : state.isFocused
                        ? '#E0F7F5'
                        : 'white',
                      color: state.isSelected ? 'white' : '#333',
                      '&:hover': {
                        backgroundColor: state.isSelected ? '#00A896' : '#E0F7F5',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Cellule</label>
                <Select
                  value={
                    formData.cellule && cellules.length > 0
                      ? cellules
                          .filter((c) => {
                            const cellValue = c.id || c.nom;
                            return cellValue == formData.cellule || c.nom === formData.cellule;
                          })
                          .map((c) => ({
                            value: c.id || c.nom,
                            label: c.nom || String(c.id || c.nom),
                          }))[0] || null
                      : null
                  }
                  onChange={handleCelluleChange}
                  options={cellules.map((c) => ({
                    value: c.id || c.nom,
                    label: c.nom || String(c.id || c.nom),
                  }))}
                  isClearable
                  isSearchable
                  placeholder={cellules.length === 0 ? "Chargement des cellules..." : "Sélectionner une cellule"}
                  isLoading={cellules.length === 0}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#d1d5db',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#00A896',
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#00A896'
                        : state.isFocused
                        ? '#E0F7F5'
                        : 'white',
                      color: state.isSelected ? 'white' : '#333',
                      '&:hover': {
                        backgroundColor: state.isSelected ? '#00A896' : '#E0F7F5',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Grade</label>
                <Select
                  value={
                    formData.grade && grades.length > 0
                      ? grades
                          .filter((g) => {
                            const gradeValue = g.id || g.nom;
                            return gradeValue == formData.grade || g.nom === formData.grade;
                          })
                          .map((g) => ({
                            value: g.id || g.nom,
                            label: g.nom || String(g.id || g.nom),
                          }))[0] || null
                      : null
                  }
                  onChange={handleGradeChange}
                  options={grades.map((g) => ({
                    value: g.id || g.nom,
                    label: g.nom || String(g.id || g.nom),
                  }))}
                  isClearable
                  isSearchable
                  placeholder={grades.length === 0 ? "Chargement des grades..." : "Sélectionner un grade"}
                  isLoading={grades.length === 0}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#d1d5db',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#00A896',
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#00A896'
                        : state.isFocused
                        ? '#E0F7F5'
                        : 'white',
                      color: state.isSelected ? 'white' : '#333',
                      '&:hover': {
                        backgroundColor: state.isSelected ? '#00A896' : '#E0F7F5',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Fonction</label>
                <Select
                  value={
                    formData.fonction && fonctions.length > 0
                      ? fonctions
                          .filter((f) => {
                            const fonctionValue = f.id || f.nom;
                            return fonctionValue == formData.fonction || f.nom === formData.fonction;
                          })
                          .map((f) => ({
                            value: f.id || f.nom,
                            label: f.nom || String(f.id || f.nom),
                          }))[0] || null
                      : null
                  }
                  onChange={handleFonctionChange}
                  options={fonctions.map((f) => ({
                    value: f.id || f.nom,
                    label: f.nom || String(f.id || f.nom),
                  }))}
                  isClearable
                  isSearchable
                  placeholder={fonctions.length === 0 ? "Chargement des fonctions..." : "Sélectionner une fonction"}
                  isLoading={fonctions.length === 0}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#d1d5db',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#00A896',
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#00A896'
                        : state.isFocused
                        ? '#E0F7F5'
                        : 'white',
                      color: state.isSelected ? 'white' : '#333',
                      '&:hover': {
                        backgroundColor: state.isSelected ? '#00A896' : '#E0F7F5',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Situation Prime</label>
                <Select
                  value={
                    situationPrimeOptions.find(
                      (option) => option.value === formData.situation_prime
                    ) || null
                  }
                  onChange={handleSituationPrimeChange}
                  options={situationPrimeOptions}
                  isClearable
                  placeholder="Sélectionner la situation"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#d1d5db',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#00A896',
                      },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? '#00A896'
                        : state.isFocused
                        ? '#E0F7F5'
                        : 'white',
                      color: state.isSelected ? 'white' : '#333',
                      '&:hover': {
                        backgroundColor: state.isSelected ? '#00A896' : '#E0F7F5',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Date d'Affectation</label>
                <input
                  type="date"
                  name="date_affectation"
                  value={formData.date_affectation}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Référence Affectation</label>
                <input
                  type="text"
                  name="ref_affectation"
                  value={formData.ref_affectation}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Zone d'Affectation</label>
                <input
                  type="text"
                  name="zone_affectation"
                  value={formData.zone_affectation}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text mb-2">Lieu d'Affectation</label>
                <input
                  type="text"
                  name="lieu_affectation"
                  value={formData.lieu_affectation}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
            </div>
          </div>

          {/* Documents */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-text mb-4">
              <i className="fas fa-images mr-2 text-primary"></i>Documents (Minimum 5 images)
            </h2>
            
            {/* Zone de drag & drop */}
            <div
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              className="border-2 border-dashed border-primary rounded-xl p-8 mb-6 bg-gradient-to-br from-primary/5 to-primary/10 hover:border-primary-dark transition-all cursor-pointer"
            >
              <div className="text-center">
                <i className="fas fa-cloud-upload-alt text-5xl text-primary mb-4"></i>
                <p className="text-lg font-medium text-text mb-2">
                  Glissez-déposez vos images ici
                </p>
                <p className="text-sm text-text-light mb-4">
                  ou cliquez pour sélectionner des fichiers
                </p>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleDocumentsChange}
                  className="hidden"
                  id="documents-input"
                />
                <label
                  htmlFor="documents-input"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-all cursor-pointer"
                >
                  <i className="fas fa-plus-circle"></i>
                  Sélectionner des images
                </label>
                <p className="text-xs text-text-light mt-3">
                  Formats acceptés: JPG, PNG, GIF, WEBP (Maximum 10MB par image)
                </p>
              </div>
            </div>

            {/* Liste des documents avec progression */}
            {documents.length > 0 && (
              <div className="space-y-4">
                <div className="flex items-center justify-between mb-4">
                  <p className="text-sm font-medium text-text">
                    {documents.length} image{documents.length > 1 ? 's' : ''} sélectionnée{documents.length > 1 ? 's' : ''}
                    {documents.length < 5 && (
                      <span className="ml-2 text-orange-600">
                        (Minimum 5 recommandé)
                      </span>
                    )}
                  </p>
                  {documents.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        documents.forEach(doc => {
                          if (doc.preview) URL.revokeObjectURL(doc.preview);
                        });
                        setDocuments([]);
                      }}
                      className="text-sm text-red-600 hover:text-red-700"
                    >
                      <i className="fas fa-trash mr-1"></i>Tout supprimer
                    </button>
                  )}
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  {documents.map((doc) => (
                    <div
                      key={doc.id}
                      className="relative group bg-white rounded-lg border-2 border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-all"
                    >
                      {/* Image preview */}
                      <div className="aspect-square relative">
                        <img
                          src={doc.preview}
                          alt={doc.name}
                          className="w-full h-full object-cover"
                        />
                        {/* Overlay avec bouton supprimer */}
                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all flex items-center justify-center">
                          <button
                            type="button"
                            onClick={() => removeDocument(doc.id)}
                            className="opacity-0 group-hover:opacity-100 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-all"
                            title="Supprimer"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        {/* Barre de progression */}
                        {doc.status === 'uploading' && (
                          <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-2">
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div
                                className="bg-primary h-2 rounded-full transition-all duration-300"
                                style={{ width: `${doc.progress}%` }}
                              ></div>
                            </div>
                            <p className="text-xs text-white mt-1 text-center">
                              {doc.progress}%
                            </p>
                          </div>
                        )}
                        {/* Badge de statut */}
                        {doc.status === 'success' && (
                          <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                            <i className="fas fa-check text-xs"></i>
                          </div>
                        )}
                        {doc.status === 'error' && (
                          <div className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full">
                            <i className="fas fa-exclamation text-xs"></i>
                          </div>
                        )}
                      </div>
                      {/* Nom du fichier */}
                      <div className="p-2">
                        <p className="text-xs text-text truncate" title={doc.name}>
                          {doc.name}
                        </p>
                        <p className="text-xs text-text-light">
                          {(doc.size / 1024 / 1024).toFixed(2)} MB
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Empreinte Digitale */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-text mb-4">
              <i className="fas fa-fingerprint mr-2 text-primary"></i>Empreinte Digitale
            </h2>
            <textarea
              name="empreinte_digitale"
              value={empreinteDigitale}
              onChange={(e) => setEmpreinteDigitale(e.target.value)}
              placeholder="Données d'empreinte digitale (simulation - à intégrer avec SDK ZKTeco)"
              rows="3"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
            />
          </div>

          {/* Message */}
          {message.text && (
            <div
              className={`mb-4 p-4 rounded-lg ${
                message.type === 'success'
                  ? 'bg-green-100 text-green-700 border border-green-400'
                  : 'bg-red-100 text-red-700 border border-red-400'
              }`}
            >
              <i
                className={`fas ${
                  message.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'
                } mr-2`}
              ></i>
              {message.text}
            </div>
          )}

          {/* Submit Button */}
          <div className="flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="px-8 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-all transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin mr-2"></i>Enregistrement...
                </>
              ) : (
                <>
                  <i className="fas fa-save mr-2"></i>Enregistrer l'Agent
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Enrolement;

